exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#landscape {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  background: #000;\n  width: 100%;\n  height: 100%;\n  z-index: 90000;\n}\n\n#landscape .landscape__icon {\n  color: #fff;\n  font-size: 9rem;\n}\n\n#landscape .landscape__text {\n  text-align: center;\n  color: #fff;\n  font-size: 2.3rem;\n  width: 13.5rem;\n  padding-top: 1rem;\n}\n\n", ""]);

// exports
